<template>
  <session class="page-productservice">
    <TopNavs :list="navs" :target="curNav" @click="target => tabNav(target)" />
    <div class="page-productservice-i js-page-productservice">
      <div ref="bannerRef">
        <Banner :title="bannerTitle" :content="bannerContent" :cover="IMG_BANNER_COVER" />
      </div>
      
      <div class="productservice-block" ref="block1Ref">
        <div class="block-header">
          <span class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ block1Title }}</span>
          <span />
        </div>
        <div class="block1-body">
          <div class="block-body-content">
            <div class="item" :class="{ active: item?.title == block1ListCurItem?.title }" v-for="(item, index) in block1List" :key="index" @click="item.action" @mouseenter="block1ListTab(index)">
              <div class="line" />
              <Icon :name="item.icon" size="40" />
              <span class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ item?.title }}</span>
              <span class="desc">{{ item?.desc }}</span>
              <div class="checkmore" ><Icon name="checkmore" size="48" /><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{ LOCAL('checkmore') }}</span></div>
            </div>
          </div>
        </div>
      </div>

      <div class="productservice-block" ref="block2Ref">
        <div class="block-header">
          <span class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ block2Title }}</span>
          <span />
        </div>
        <div class="block2-body">
          <div class="block-body-content">
            <div class="item" :class="{ active: item?.title == block2ListCurItem?.title }" v-for="(item, index) in block2List" :key="index" @click="block2ListTab(index)">
              <div class="cover" :style="{ backgroundImage: `url(${item.cover})` }" />
              <span class="name">{{ item?.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  </session>
</template>

<script setup>
  import { ref, onMounted } from 'vue';
  import * as Utils from '@/assets/utils';
  import Banner from '@/components/banner/index.vue';
  import TopNavs from '@/components/topnavs/index.vue';
  import Icon from '@/components/icon/index.vue';
  import Footer from '@/components/footer/index.vue';
  import { LOCAL, getLocalLangCode } from '@/assets/lang';
  import EventBus from '@/assets/eventbus';

  // imgs
  import IMG_BANNER_COVER from './images/cover.png';
  import IMG_PARTNER_AIA from './images/aia.png';
  import IMG_PARTNER_AXA from './images/axa.png';
  import IMG_PARTNER_HSBC from './images/hsbc.png';
  import IMG_PARTNER_NISSAY from './images/nissay.png';
  import IMG_PARTNER_SL from './images/sl.png';
import router from '@/router';


  /**
   * navs
   */
  // nav list
  const navs = ref([
    { id: 1, label: LOCAL('productservice_productService') },
    { id: 2, label: LOCAL('productservice_coveragePlans') },
    { id: 3, label: LOCAL('productservice_partners') },
  ]);
  // nav target
  const bannerRef = ref(null);
  const block1Ref = ref(null);
  const block2Ref = ref(null);
  // cur nav
  const curNav = ref(null)
  const tabNav = (target, isJump) => {
    console.log('target', target, "isJump", isJump)
    if(isJump) {
      curNav.value = target;
      return;
    }

    // 滚动到……
    if(target?.id == 1 && bannerRef.value) {
      bannerRef.value.scrollIntoView({ behavior: 'smooth', block: 'start', inline: "nearest" });
    }
    if(target?.id == 2 && block1Ref.value) {
      block1Ref.value.scrollIntoView({ behavior: 'smooth', block: 'start', inline: "nearest" });  
    }
    if(target?.id == 3 && block2Ref.value) {
      block2Ref.value.scrollIntoView({ behavior: 'smooth', block: 'start', inline: "nearest" });  
    }
  }
  onMounted(() => {
    tabNav(navs.value[0], true);
  });
  const scrollHandle = () => {
    const el = document.querySelector('.js-page-productservice');
    el.addEventListener('scroll', e => {
      const curpoi = e.target.scrollTop + 84 + 78;
      if(curpoi > block2Ref.value.offsetTop){
        tabNav(navs.value[2], true);
      }else if(curpoi > block1Ref.value.offsetTop){
        tabNav(navs.value[1], true);
      }else if(curpoi > bannerRef.value.offsetTop){
        tabNav(navs.value[0], true);
      }
    });
  }
  onMounted(() => {
    scrollHandle()
  });

  // banner
  const bannerTitle = ref('')
  const bannerContent = ref('')
  const bannerInit = () => {
    bannerTitle.value = LOCAL('productservice_productService');
    bannerContent.value = LOCAL('productservice_productService_desc');
  }
  onMounted(() => {
    bannerInit()
  })

  // 保障计划
  const block1Title = ref('');
  const block1List = ref([]);
  const block1ListCurItem = ref(null);
  const block1ListTab = (index = 0) => {
    block1ListCurItem.value = block1List.value[index];
  }
  const block1Init = () => {
    block1Title.value = LOCAL('productservice_coveragePlans');
    block1List.value = [
      { 
        icon: 'gerenbaozhang', 
        title: LOCAL('productservice_coveragePlans_person'), 
        desc: LOCAL('productservice_coveragePlans_person_desc'),
        action: () => router.push('/plan/person')
      },
      { 
        icon: 'jigoubaozhang',
        title: LOCAL('productservice_coveragePlans_unit'), 
        desc: LOCAL('productservice_coveragePlans_unit_desc'),
        action: () => router.push('/plan/unit')
      },
    ]
  }
  onMounted(() => {
    block1Init();
    block1ListTab();
  })

  // 合作伙伴
  const block2Title = ref('')
  const block2List = ref([]);
  const block2ListCurItem = ref(null);
  const block2ListTab = (index = 0) => {
    block2ListCurItem.value = block2List.value[index];
  }
  const block2Init = () => {
    block2Title.value = LOCAL('productservice_partners');
    block2List.value = [
      { name: LOCAL('productservice_partners_axa'), cover: IMG_PARTNER_AXA },
      { name: LOCAL('productservice_partners_nissay'), cover: IMG_PARTNER_NISSAY },
      { name: LOCAL('productservice_partners_hsbc'), cover: IMG_PARTNER_HSBC },
      { name: LOCAL('productservice_partners_sl'), cover: IMG_PARTNER_SL },
      { name: LOCAL('productservice_partners_aia'), cover: IMG_PARTNER_AIA },
    ]
  }
  onMounted(() => {
    block2Init();
    block2ListTab();
  })

  // 左侧回到顶部交互
  onMounted(() => {
    Utils.scrollToTop.register('js-page-productservice');
    EventBus.on('global_page_scroll_action_js-page-productservice', () => {
      tabNav(navs.value[0]);
    });
  });
</script>

<style scoped lang="less">
  @import "index.less";
</style>
